import type {StatusColor} from '../types';
import {ThemeColors} from '../themeColors';

export const useStatusColor = (
  color: StatusColor | undefined,
): string | undefined => (color ? ThemeColors.status[color] : undefined);
